export const environment = {
  production: false,
  isLocal: false,
  environment: 'dev',
  system: '',
  useSharedSession: true,
  api: {
    baseUrl: 'https://www.qa.samsungdss.com',
    backend: '/api',
  },

  pusher: {
    appKey: '8a21f0fb47d37845216a',
    cluster: 'mt1',
    authEndpoint: '/auth/pusher',
  },
  mapKey: 'AIzaSyDhYvSH_Fl0rNEXeKSKeesv_ZX03HgH6nk',
};
